import { AfterViewInit, Component, Input, QueryList, ViewChildren, ChangeDetectorRef, AfterContentChecked, ViewChild, inject, DestroyRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { NamedTemplateDirective } from 'src/app/directives/named-template.directive';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { DynamicFormModel } from 'src/app/models/service/dynamic-form-model';
import { InstallationSchemaPropertyType } from 'src/app/models/service/installation-schema-property-type';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { CobStatus } from 'src/app/models/deploy/cob-status';


@Component({
    selector: 'app-dynamic-form',
    templateUrl: './dynamic-form.component.html',
    styleUrls: ['./dynamic-form.component.scss'],
    standalone: false
})
export class DynamicFormComponent  implements AfterViewInit, AfterContentChecked {
  @Input() instanceName: any;
  @Input() cobStatus: any;
  @Input() dynamicFormModel: DynamicFormModel;
  @Input() showTopLevelTitle = true;
  private destroyRef = inject(DestroyRef);
  CobStatus = CobStatus;
  daysSch1: any = [
    {
      name: 'Sunday',
      value: 'SUN',
      checked: false
    },
    {
      name: 'Monday',
      value: 'MON',
      checked: false
    },
    {
      name: 'Tuesday',
      value: 'TUE',
      checked: false
    },
    {
      name: 'Wednesday',
      value: 'WED',
      checked: false
    },
    {
      name: 'Thursday',
      value: 'THU',
      checked: false
    },
    {
      name: 'Friday',
      value: 'FRI',
      checked: false
    },
    {
      name: 'Saturday',
      value: 'SAT',
      checked: false
    },
  ];
  daysSch2: any = [
    {
      name: 'Sunday',
      value: 'SUN',
      checked: false
    },
    {
      name: 'Monday',
      value: 'MON',
      checked: false
    },
    {
      name: 'Tuesday',
      value: 'TUE',
      checked: false
    },
    {
      name: 'Wednesday',
      value: 'WED',
      checked: false
    },
    {
      name: 'Thursday',
      value: 'THU',
      checked: false
    },
    {
      name: 'Friday',
      value: 'FRI',
      checked: false
    },
    {
      name: 'Saturday',
      value: 'SAT',
      checked: false
    },
  ];
  @ViewChildren(NamedTemplateDirective) templates: QueryList<NamedTemplateDirective>;
  templatesMap: KeyValueMap<string, NamedTemplateDirective>;

  InstallationSchemaPropertyType = InstallationSchemaPropertyType;
  scheduleTwo = false;
  scheduleOne = true;
  weekDaysSelectedSch1: string;
  weekDaysSelectedSch2: string;
  hoursMinutesSch1: FormGroup;
  hoursMinutesSch2: FormGroup;
  sch1Value: string;
  sch2Value: string;
  bothSameValue: boolean;
  requiredError: boolean;
  atleastOneDay: boolean;
  hasError = false;
  constructor(private dialog: MatDialog, private changeDetector: ChangeDetectorRef, private fb: FormBuilder, public sidenavService: SidenavService) {
    
  }

  ngAfterViewInit(): void {
    this.hoursMinutesSch1 = this.fb.group({
      hours: ['0'],
      minutes: ['0']
    });
    this.hoursMinutesSch2 = this.fb.group({
      hours: ['0'],
      minutes: ['0']
    });
    if(this.cobStatus === CobStatus.RECONFIGURE || this.cobStatus === CobStatus.UPDATE) {
      const sch1Edit = this.dynamicFormModel.formGroup.controls[this.dynamicFormModel.property.name].value.Schedule1.split(" ");
      if(sch1Edit[4] && sch1Edit[4].includes(',')) {
      const weekDays1 = sch1Edit[4].split(',');
          weekDays1.forEach(day => {
            this.daysSch1.find(item => {
              if(item.value === day) {
                item.checked = true;
              }
            })
          })
        } else if(sch1Edit[4] !== '*') {
          this.daysSch1.find(item => {
            if(item.value === sch1Edit[4]) {
              item.checked = true;
            }
          })
        }
      this.hoursMinutesSch1.patchValue({
        hours: sch1Edit[1] ? sch1Edit[1] : 0,
        minutes: sch1Edit[0] ? sch1Edit[0] : 0
      });
      let weeksDays = [];
      this.daysSch1.filter(item => {
      if(item.checked) {
        weeksDays.push(item.value);
        }
      })
      this.weekDaysSelectedSch1 = weeksDays.toString();
      const sch2Edit = this.dynamicFormModel.formGroup.controls[this.dynamicFormModel.property.name].value.Schedule2.split(" ");
      if(sch2Edit[4] && sch2Edit[4].includes(',')) {
      const weekDays2 = sch2Edit[4].split(',');
          weekDays2.forEach(day => {
            this.daysSch2.find(item => {
              if(item.value === day) {
                item.checked = true;
              }
            })
          })
        } else if(sch2Edit[4] !== '*') {
          this.daysSch2.find(item => {
            if(item.value === sch2Edit[4]) {
              item.checked = true;
            }
          })
        }
      this.hoursMinutesSch2.patchValue({
        hours: sch2Edit[1] ? sch2Edit[1] : 0,
        minutes: sch2Edit[0] ? sch2Edit[0] : 0
      });
      let weeksDays2 = [];
      this.daysSch2.filter(item => {
        if(item.checked) {
          weeksDays2.push(item.value);
        }
      })
    this.weekDaysSelectedSch2 = weeksDays2.toString();
    }
    if(this.cobStatus === CobStatus.RECONFIGURE) {
      const fields = this.dynamicFormModel.property.properties.map(item => item.name);
      fields.forEach(item => {
        const data:any = this.dynamicFormModel.property.properties.find(index => index.name === item);
        if(!data.updatedValue || data.updatedValue === "false") {
        this.dynamicFormModel.formGroup.controls[this.dynamicFormModel.property.name]?.get(item).disable();
        }
      })

    }
    this.dynamicFormModel.property.properties.forEach((element: any) => {
      element.customName = element.name.toLowerCase();
    });
    setTimeout(() => {
      this.templatesMap = this.templates.reduce((accumulator, currentValue) => {
        accumulator[currentValue.appNamedTemplate] = currentValue.template;
        return accumulator;
      }, {});
    });
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  public cobTabs(event?): void {
    if (event === 'schedule1') {
      this.scheduleOne = true;
      this.scheduleTwo = false;
    } else if (event === 'schedule2') {
      this.scheduleOne = false;
      this.scheduleTwo = true;
    }
  }

  selectDays(data): void {
    if(this.scheduleOne) {
      this.daysSch1.find(item => {
        if(item.name === data.name) {
          item.checked = !item.checked;
        }
      })
      let weeksDays = [];
      this.daysSch1.filter(item => {
        if(item.checked) {
          weeksDays.push(item.value);
        }
      })
      this.weekDaysSelectedSch1 = weeksDays.toString();
    } else {
      this.daysSch2.find(item => {
        if(item.name === data.name) {
          item.checked = !item.checked;
        }
      })
      let weeksDays2 = [];
      this.daysSch2.filter(item => {
        if(item.checked) {
          weeksDays2.push(item.value);
        }
      })
      this.weekDaysSelectedSch2 = weeksDays2.toString();
    }
    }  

  closeSidenav(data): void {
    this.dynamicFormModel.formGroup.controls[this.dynamicFormModel.property.name].get('Schedule1').setErrors(null);
    this.dynamicFormModel.formGroup.controls[this.dynamicFormModel.property.name].get('Schedule2').setErrors(null);
    this.sch1Value = this.hoursMinutesSch1.get('minutes').value.toString() + ' ' + this.hoursMinutesSch1.get('hours').value.toString() + ' ' + 
        '* *' + ' ' + (this.weekDaysSelectedSch1 ? this.weekDaysSelectedSch1 : '*');
      this.sch2Value = this.hoursMinutesSch2.get('minutes').value.toString() + ' ' + this.hoursMinutesSch2.get('hours').value.toString() + ' ' + 
      '* *' + ' ' + (this.weekDaysSelectedSch2 ? this.weekDaysSelectedSch2 : '*');
    if(data && FormUtilService.validateForm(this.dynamicFormModel.formGroup) && this.sch1Value !== '0 0 * * *') {
      if(this.sch1Value !== this.sch2Value) {
        if(this.sch1Value.split(' ')[4].toString() !== '*') {
        this.bothSameValue = false;
        this.requiredError = false;
        this.atleastOneDay = false;
        this.dialog.open(ConfirmationDialogComponent, {
          panelClass: 'default-dialog-wrapper',
          width: '566px',
          autoFocus: false,
          data: {
            title: this.cobStatus === CobStatus.RECONFIGURE ? translate('INSTANCE_DETAILS.COB_RECONFIRM') : translate('INSTANCE_DETAILS.COB_CONFIRM'),
            message: this.cobStatus === CobStatus.RECONFIGURE ? translate('INSTANCE_DETAILS.COB_RECONFIRM_MESSAGE') : translate('INSTANCE_DETAILS.COB_CONFIRM_MESSAGE'),
            confirmButtonText: translate('BUTTONS.SAVE')
          }
        })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            if(this.sch1Value === '0 0 * * *') {
              this.sch1Value = '';
            }
            if(this.sch2Value === '0 0 * * *') {
              this.sch2Value = '';
            }
            const data = this.dynamicFormModel.formGroup.controls[this.dynamicFormModel.property.name].getRawValue();
            if(data) {
              data.Schedule1 = this.sch1Value;
              data.Schedule2 = this.sch2Value;
            }
            this.dynamicFormModel.formGroup.controls[this.dynamicFormModel.property.name].setValue(data);
        this.sidenavService.closeRightSidenav(this.dynamicFormModel);
          }
        })
      } else {
        this.atleastOneDay = true;
        this.requiredError = false;
        this.bothSameValue = false;
      }
      } else {
        this.requiredError = false;
        this.bothSameValue = true;
        this.atleastOneDay = false;
      }
      } else {
          this.requiredError = true;
          this.bothSameValue = false;
          this.atleastOneDay = false;
        }
      }

  setProperties(control, defaultDesc, field?, property?): any {
    if (field === 'boolean') {
      control.value = control.value === 'true' || control.value === true ? true : false;
      if (property.updatedValue && property.updatedValue !== 'false' && (this.cobStatus === CobStatus.RECONFIGURE)) {
        control.disable();
      }
    }
    if(!control.value && !control.dirty && defaultDesc) {
      control.setValue(defaultDesc);
    }
    return control;
  }

  addTag($event: MatChipInputEvent, control: FormControl): void {
    $event.value.split(',').forEach(tag => {
      const trimmedTag = tag.trim();
      if (trimmedTag !== '' && !this.isDuplicateTag(trimmedTag, control)) {
        control.value.push(tag);
      }
    });
    control.updateValueAndValidity();
    $event.chipInput.inputElement.value = '';
  }

  selectTag($event: MatAutocompleteSelectedEvent, control: FormControl): void {
    if (!this.isDuplicateTag($event.option.value, control)) {
      control.value.push($event.option.value);
      control.updateValueAndValidity();
    }
  }

  removeTag(index: number, control: FormControl): void {
    control.value.splice(index, 1);
    control.updateValueAndValidity();
  }

  selectedValues(tag, property): any {
    return property?.updatedValue?.find(find=> find === tag);
  }

  setMultiSelectProperties(control, defaultVal): any {
    if(control.value.length === 0 && !control.dirty && defaultVal) {
      control.setValue([defaultVal]);
    }
    return control;
  }

  disableMultiselectField(property): any {
    if (property?.updatedValue) {
      return property?.updatedValue?.length === property?.items?.enum?.length;
    }
  }

  private isDuplicateTag(tag: string, control: FormControl): boolean {
    return control.value.find(value => value.toLowerCase() === tag.toLowerCase());
  }
}
